import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  SideTrackTriggerPageDTO,
  SideTrackTriggerParams,
  SideTrackTriggersService,
} from '../tokens/side-track-triggers.token';

/**
 * REST-only implementation of SideTrackTriggersService.
 *
 * Calls GET /services/embedded/api/master-admin/side-track-triggers.
 * Authority: ROLE_MASTER_ADMIN (enforced on the backend; the portal's roleGuard
 * also restricts the route to master_admin).
 *
 * EM-213 / ST-7.
 */
@Injectable({ providedIn: 'root' })
export class SideTrackTriggersRestService implements SideTrackTriggersService {
  private readonly http = inject(HttpClient);

  private readonly BASE_URL =
    '/services/embedded/api/master-admin/side-track-triggers';

  query(params: SideTrackTriggerParams): Observable<SideTrackTriggerPageDTO> {
    let httpParams = new HttpParams()
      .set('page', String(params.page))
      .set('size', String(params.size));

    if (params.trigger) {
      httpParams = httpParams.set('trigger', params.trigger);
    }
    if (params.applicationId != null) {
      httpParams = httpParams.set('applicationId', String(params.applicationId));
    }
    if (params.from) {
      httpParams = httpParams.set('from', params.from);
    }
    if (params.to) {
      httpParams = httpParams.set('to', params.to);
    }

    return this.http.get<SideTrackTriggerPageDTO>(this.BASE_URL, {
      params: httpParams,
    });
  }
}
